export const Bio = {
  name: "Abhishek Nikam",
  roles: [
    "Full Stack Developer",
    "Android Developer",
    "Programmer",
  ],
  description:
    "Enthusiastic tech learner with a positive attitude and growth mindset. Big thinker ready to make meaningful contributions and achieve greater things. Excited about the endless possibilities in the world of technology",
  github: "https://github.com/Abhisheknik",
  resume:
    "https://abhisheknikam.tiiny.site/",
  linkedin: "https://www.linkedin.com/in/abhishek-nikam/",
  insta: "https://www.instagram.com/abhiz_hek/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "PHP",
        image:
          "https://seeklogo.com/images/P/php-logo-DC4A01DBB6-seeklogo.com.png",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Asp .Net",
        image:
          "https://seeklogo.com/images/M/microsoft-net-logo-631EFE744A-seeklogo.com.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://seeklogo.com/images/P/postman-logo-0087CA0D15-seeklogo.com.png",
      },
      {
        name: "Figma",
        image:
          "https://seeklogo.com/images/F/figma-logo-E4E21D3AEA-seeklogo.com.png",
      },
      {
        name: "Api",
        image: "https://cdn.iconscout.com/icon/premium/png-512-thumb/api-integration-3919433-3246625.png?f=webp&w=256",
      },
      {
        name:"Pursing N4 japanese",
        image: "https://upload.wikimedia.org/wikipedia/en/thumb/9/9e/Flag_of_Japan.svg/1200px-Flag_of_Japan.svg.png?20111003030759",
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/D4D0BAQEXGmbdDZiSvQ/company-logo_200_200/company-logo_200_200/0/1681793208677/imocha_logo?e=1736985600&v=beta&t=y5Qg99fIe7CfMOcbh6kngN9IOsbhaxz85nzRAB0RdYE",
    role: "BackEnd Developer",
    company: "iMocha",
    date: "Sept 2024 - Present",
    desc: "Working on Report Engine and API Development, Learning new things and working on new technologies",
    skills: [
      ".Net",
      "C#",
      "Azure DevOps",
    ],
  },
   {
    id: 0,
    img: "https://media.licdn.com/dms/image/D4D0BAQFSY_UYw62ikQ/company-logo_200_200/0/1690433742597?e=1732147200&v=beta&t=X-66AW1QmFBZTfKM4RS2n7nqcqAKqusT6xUuMIx0Qe8",
    role: "Flutter Developer",
    company: "Probity",
    date: "Jan 2024 - June 2024 · 6 mos",
    desc: "Cross Platform App Development Domin , remarkable Projects and learn new things",
    skills: [
      "Mobile Application Development",
      "Flutter"
    ],
  },
  {
    id: 0,
    img: "https://www.ecell.in/mainpage/assets/images/logo.webp",
    role: "Campus Executive",
    company: "E-Cell, IIT Bombay",
    date: "Jul 2023 - Present · 7 mos",
    desc: "As a Campus Executive at E-Cell, IIT Bombay, my role involves organizing events, building a supportive entrepreneurial community, developing business skills, networking with entrepreneurs, promoting entrepreneurship on campus, fostering innovation, and providing leadership and mentorship opportunities.",
    skills: [
      "Communication",
      "Team Management",
    ],
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQdmIQSdD76lhUcGRQlGMKxvPMcIt4cY3Ddew&s",
    role: "Open Source Contributor",
    company: "Hacktoberfest-MLSC",
    date: "Sept 2023 - Nov 2023",
    desc: "Contributed to Hacktoberfest by participating in various open-source projects. This experience not only allows me to contribute to the community but also helps me learn more about open source",
    skills: [
      "HTML",
      "CSS",
      "JS",
      "API",
      "Database",
      "Git",
      "Github",
      "Version control",
    ],
  },
  {
    id: 2,
    img: "https://www.microsoft.com/favicon.ico?v2",
    role: "Future Ready Talent ",
    company: "Microsoft",
    date: "May 2022 - Dec 2022 · 8 mos",
    desc: "- Learning Modules provided by Microsoft on Azure , Cyber security , Artificial intelligence , Unity , GitHub ,Solve Quiz based on learning.",
    skills: [
      "JavaScript",
      "HTML5",
      "Bootstrap",
      "Web Applications",
      "Chatbots",
      "Microsoft Azure",
      "Cascading Style Sheets (CSS)",
    ],
  },

  {
    id: 3,
    img: "https://alphonsol.com/assests/images/favicon.png",
    role: "Software Developer",
    company: "Alphonsol Private Limited",
    date: "Jun 2022 - Nov 2022 · 6 mos",
    desc: "Developed a PHP-based 365 Care Web App with Codeigniter, featuring modular design. Conducted SEO for Imset, Bioxia, and Cleanroom companies using Google Tools. Implemented technical enhancements for the IMSET website. Created a REST API with detailed documentation, including purpose, endpoints, authentication, methods, data format, and security measures.",
    skills: [
      "JavaScript",
      "HTML5",
      "Bootstrap",
      "Microsoft SQL Server",
      "CodeIgniter",
      "ASP.NET",
      "C#",
      "Cascading Style Sheets (CSS)",
    ],
  },
  {
    id: 4,
    img: "https://www.datamatics.com/hubfs/favicon-32x32.png",
    role: "Associate",
    company: "Datamatics",
    date: "Apr 2021 - Sep 2021 · 6 mos",
    skills: [
      "Android",
      "Quality Control ",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://gesociety.in/wp-content/uploads/2018/05/logo.png",
    school: "Gokhale Education Society's R. H. Sapat College of Engineering, Management Studies and Research",
    date: "Oct 2022 - May 2024",
    grade: "8.24 CGPA First Class With Distinction",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Kalinga Institute of Industrial Technology, Bhubaneswar. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Master of Computer Application (Engineering)",
  },
  {
    id: 1,
    img: "https://kthmcollege.ac.in/images/logo.png",
    school: "KRT Arts, BH Commerce and AM Science (KTHM) College, Nashik",
    date: "Apr 2019 - Apr 2022",
    grade: "7.53 CGPA",
    desc: "Done a Computer Science ",
    degree: "Bachelor in Computer Science",
  },
];

export const projects = [
   {
    id: 13,
    title: "SlamBook ",
    date: "Aug 2024",
    description:
      "SlamBook is a web application built using Python, HTML, and CSS to create a modern digital SlamBook experience. The app is containerized with Docker, using Docker volumes for persistent storage, and deployed on Azure App Service. It allows users to submit their details via a web form, with data securely stored in Azure services",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/Screenshot%202024-11-23%20102544.png?alt=media&token=1d13272a-2f19-4d77-9097-2375196c3fb5",
    tags: [
      "Docker",
      "Azure Web Services",
      "Python",
      "Flask",
      "CI/CD",
      "HTML/CSS",
    ],
    category: "web app",
    github: "https://github.com/Abhisheknik/Slambook",
    webapp:"https://slambook.azurewebsites.net/",
  },
  {
    id: 12,
    title: "React Js CRUD ",
    date: "Aug 2024",
    description:
      "React js CRUD opreation with db.json follow the all basic operation ",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/Screenshot%202024-08-18%20095812.png?alt=media&token=fa25f444-bd7d-49ae-ba31-791aaa2a69cb",
    tags: [
      "React js",
      "Json",
      "API",
    ],
    category: "web app",
    github: "https://github.com/Abhisheknik/React.js-CRUD",
    webapp:"https://react-jscrud.netlify.app/",
  },
  {
    id: 11,
    title: "Megan AI APP",
    date: "July 2024",
    description:
      "MEGAN (Machine Enhanced Gateway for AI Networking) is a comprehensive mobile app that integrates various AI tools into one platform. ",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/Screenshot%202024-08-18%20095718.png?alt=media&token=1c07d6ff-70d1-4ac0-b2bd-6165ba2d9adc",
    tags: [
      "Flutter",
      "Firebase",
      "API",
      "AI",
      "Razorpay",
    ],
    category: "app",
    github: "https://github.com/Abhisheknik/Megan_Ai_hub",
  },
  {
    id: 6,
    title: "OCR Text Extractor",
    date: "July 2024",
    description:
      "OCR text extractor in Python to automate pulling data from medical documents. ",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/Screenshot%202024-07-08%20102412.png?alt=media&token=374b9435-d300-454b-9f8f-5cbc4450f8af",
    tags: [
      "Python",
      "Pytesseract",
      "Pandas",
      "Streamlit",
    ],
    category: "web app",
    github: "https://github.com/Abhisheknik/ocr-text-extract",
  },
  {
    id: 9,
    title: "To Do List.Flutter",
    date: "Aug 2023",
    description:
      "Flutter Todo List app for streamlined task management, created in Visual Studio Code. Prioritize, organize, and mark completed tasks with a user-friendly interface for enhanced productivity.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/todo.png?alt=media&token=fa92720e-e204-4a9d-9b53-5a7d01e7af26",
    tags: [
      "Dart",
      "Flutter",
      "VScode",
    ],
    category: "app",
    github: "https://github.com/Abhisheknik/Todolist_CodeSoft",
  },
  {
    id: 0,
    title: "Magi 2.0",
    date: "Dec 2023",
    description:
      "Developed a cutting-edge web application leveraging DALL-E 3 API for seamless text-to-image generation. The platform not only showcases innovative visual content but also features a fully integrated e-commerce section offering a diverse range of merchandise. To ensure secure transactions, the app seamlessly integrates with the Stripe payment gateway, providing users with a secure and convenient shopping experience. Explore a fusion of creativity and commerce on this unique web app.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/magi.jpg?alt=media&token=26402123-f177-4d25-8c8f-31cbc270ac3b",
    tags: ["HTML", "CSS", "Node Js", "Express Js", "Firebase", "Dalle 3 Api", "Stripe"],
    category: "web app",
    github: "https://github.com/Abhisheknik/Magi2.0",
    member: [
      {
        name: "Abhishek Nikam",
        img: "https://avatars.githubusercontent.com/u/79035081?v=4",
        linkedin: "https://www.linkedin.com/in/abhishek-nikam/",
        github: "https://github.com/Abhisheknik",
      },
      {
        name: "Bhagwatilal Joshi",
        img: "https://avatars.githubusercontent.com/u/139034588?v=4",
        linkedin: "https://linkedin.com/in/bhagwatilal-joshi-863b14264",
        github: "https://github.com/Bhagwatilal",
      },
    ],
  },
  {
    id: 1,
    title: "Calculator",
    date: "Oct 2023",
    description:
      "Crafted a sleek and functional calculator app using Flutter, providing users with a smooth and intuitive calculation experience. Whether you're crunching numbers on the go or tackling complex calculations, this app offers a user-friendly interface and reliable performance. Simplify your math tasks with my Flutter calculator app.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/cal.jpg?alt=media&token=f4c1aee7-68ac-4e71-a6f2-856089ee731d",
    tags: [
      "Dart",
      "Flutter",
      "Vscode",
    ],
    category: "app",
    github: "https://github.com/Abhisheknik/CodeSoft_CAL_Appilca",
  },
  {
    id: 2,
    title: "Drum Kit",
    date: "Mar 2023",
    description:
      "Designed an interactive Drum Kit using a combination of HTML, CSS, and JavaScript. Immerse yourself in the world of percussion as you play various drums with just a click or tap. The user-friendly interface and responsive design ensure an engaging and rhythmic experience. Start making beats and express your musical creativity with this dynamic Drum Kit web application.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/drum.png?alt=media&token=7b29a2f6-4f69-426d-aa07-9c97334e44e1",
    tags: ["HTML", "Javascript", "CSS", "Bootstrap"],
    category: "web apps",
    github: "https://github.com/Abhisheknik/Drum-Kit",
    webapp: "https://rock-drum-kit.netlify.app/",
  },
  {
    id: 3,
    title: "Sorting visualizer",
    date: "Apr 2022",
    description:
      "Developed a Sorting Visualizer using JavaScript, HTML, CSS, and Bootstrap. Immerse yourself in the fascinating world of sorting algorithms as you watch the elements dynamically rearrange themselves in real-time. The user-friendly interface, coupled with Bootstrap's sleek design, provides an intuitive experience for visualizing sorting processes. Explore the efficiency and beauty of sorting algorithms through this interactive and educational Sorting Visualizer.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/sorting.png?alt=media&token=db32f507-474c-4277-b9a9-ca2f55f833ea",
    tags: ["HTML", "CSS", "Javascript", "DSA","Bootstrap"],
    category: "web app",
    github: "https://github.com/Abhisheknik/SortingAlgorithmV",
    webapp: "https://sortingvisualizera.netlify.app/",
  },
  {
    id: 10,
    title: "Save Earth",
    date: "Dec 2022",
    description:
      "I've built a Nature Awareness Web App that harnesses the power of Microsoft Azure services. This web application seamlessly integrates Azure's cloud services, a responsive design crafted with HTML and CSS, and dynamic functionality powered by JavaScript. The inclusion of a chatbot enhances user interaction and engagement, providing valuable information and assistance on nature-related topics. Explore and heighten your awareness of nature through this innovative and informative web app, combining the strength of Microsoft Azure with an intuitive user interface.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/eart.png?alt=media&token=ac7b67c3-9b00-4bb9-aa60-cb08b34fda70",
    tags: ["Microsoft Azure Services", "JavaScript", "ChatBot","HTML","CSS","Bootstrap"],
    category: "web app",
    github: "https://github.com/Abhisheknik/SaveEarth",
    webapp: "https://savearthh.netlify.app/",
  },
  {
    id: 4,
    title: "Temperature Calulator",
    date: "Oct 2023",
    description:
      "I've crafted a Temperature Converter web application using HTML, CSS, and JavaScript. This user-friendly tool allows you to effortlessly convert temperatures between Celsius, Fahrenheit, and Kelvin. The stylish interface, designed with HTML and CSS, complements the seamless functionality powered by JavaScript. Whether you're planning a trip or simply curious about temperature conversions, this web app provides a quick and intuitive solution. Experience the convenience of temperature conversion with this sleek and responsive Temperature Converter.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/temp.png?alt=media&token=2393334e-af50-4070-8382-fffa3cc5b2e6",
    tags: ["HTML", "Javascript", "CSS", "Boostrap"],
    category: "web app",
    github: "https://github.com/Abhisheknik/TemperatureConv",
    webapp: "https://tempconik.netlify.app/",
  },
  {
    id: 5,
    title: "NetFlix Clone",
    date: "Nov 2023",
    description:
      "I've created a Netflix clone using HTML, CSS, and JavaScript, offering a sleek and interactive browsing experience. While it doesn't stream actual content, the design mirrors the real Netflix platform, allowing users to explore and interact with a library of shows and movies.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/adad-b1b1d.appspot.com/o/netflixclone.png?alt=media&token=579eb243-2d82-4a91-a05a-f987a9a1da38",
    tags: ["HTML", "CSS", "JavaScript", "Bootstrap"],
    category: "web app",
    github: "https://github.com/Abhisheknik/bharatintern/tree/main/Netflix%20clone",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
